import React, { useState, useRef, useEffect } from "react";
import AbstrctImg from "../../assets/images/Card-Abstract.svg";
import StudentImg from "../../assets/images/student.png";
import ModalWindow from "../UI/ModalWindow";
import RollNumberModal from "./RollNumberModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { serverLocation } from "../../utils/Constants";
import RegistrationNumberModal from "./EditRegistrationNumberModal";

const StudentFlipCard = ({
  student,
  refetchStudents,
  toggleMenu,
  menuRowId,
  setMenuRowId,
}) => {
  const [rollNumberModal, setRollNumberModal] = useState(false);
  const [registrationNumberModal, setRegistrationNumberModal] = useState(false);
  const imagePath = `${serverLocation}/xvzfyhojcdeQnrIvAZVmgf3Sb1AoNmfA.ZQz851AchimYgyRW8.rgSFIdxjur80Wefgjkhskjhdnkdslkdji`;
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuRowId(null);
      }
    };

    if (menuRowId === student.admissionId) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRowId, student.admissionId]);

  return (
    <>
      <div className="student-flip-card">
        <div className="student-flip-card-inner">
          <div className="student-flip-card-front">
            <a href={`/profile/${student?.peopleDetail?.username}`}>
              <div className="front">
                <div className="front-top">
                  <img src={AbstrctImg} />
                </div>
                <div className="img-bg">
                  <img
                    src={
                      student?.peopleDetail?.imagePath
                        ? `${imagePath}/${student?.peopleDetail?.imagePath}`
                        : StudentImg
                    }
                    alt="student image"
                  />
                </div>
                <div className="detail">
                  <h5>
                    {student?.peopleDetail?.customDetails?.firstName}{" "}
                    <span>
                      {student?.peopleDetail?.customDetails?.lastName}
                    </span>
                  </h5>
                  {student?.admissionStatus === "ASSIGNED" ? (
                    <p style={{ margin: "0 0 2px 0" }}>
                      Class {student?.yearLevel?.name} /{" "}
                      {student?.classRoom?.name}
                    </p>
                  ) : (
                    <p style={{ margin: "0 0 4px 0" }}>Unassigned</p>
                  )}
                  <p style={{ margin: "0 auto 4px" }} className="ellipsis">
                    Roll Number: {student?.roll ?? "N/A"}
                  </p>
                  {student?.registrationNumber && (
                    <p style={{ margin: "0 auto 4px" }} className="ellipsis">
                      Registration Number: {student?.registrationNumber}
                    </p>
                  )}
                </div>
                <div className="front-bottom">
                  <img src={AbstrctImg} />
                </div>
              </div>
            </a>
          </div>
          <div className="student-flip-card-back">
            <a href={`/profile/${student?.peopleDetail?.username}`}>
              <div className="back">
                <div className="back-top">
                  <img src={AbstrctImg} />
                </div>
                <div className="student">
                  <h5>Student Details</h5>
                  <p className="ellipsis">
                    Gender: {student?.peopleDetail?.gender}
                  </p>
                  <p className="ellipsis">
                    Address:{" "}
                    {student?.peopleDetail?.customDetails?.streetAddress ??
                      "N/A"}
                  </p>
                </div>
                <div className="contact">
                  <h5>Contact Details</h5>
                  <p className="ellipsis">
                    Name: {student?.contacts[0]?.contactPeople?.fullName}
                  </p>
                  <p className="ellipsis">
                    Relationship:{" "}
                    {student?.contacts[0]?.relationship.name ?? "N/A"}
                  </p>
                  <p className="ellipsis">
                    Contact:{" "}
                    {student?.contacts[0]?.contactPeople?.contactNumber ??
                      "N/A"}
                  </p>
                </div>
                <div className="back-bottom">
                  <img src={AbstrctImg} />
                </div>
              </div>
            </a>
            <div
              ref={menuRef}
              className="flex flip-cards-btn menu-container"
              style={{ gap: "10px" }}
            >
              <button
                className="menu-btn"
                onClick={() => toggleMenu(student?.admissionId)}
              >
                <FontAwesomeIcon fontSize={16} icon={faEllipsisV} />
              </button>
              {menuRowId === student?.admissionId && (
                <div className="menu">
                  <button
                    onClick={() => setRegistrationNumberModal((prev) => !prev)}
                    className="edit-roll-btn"
                  >
                    Edit Registration Number
                  </button>
                  <button
                    onClick={() => setRollNumberModal((prev) => !prev)}
                    className="edit-roll-btn"
                  >
                    Edit Roll Number
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalWindow
        modal={rollNumberModal}
        modalHeader={"Edit Roll Number"}
        toggleModal={() => setRollNumberModal((prev) => !prev)}
        modalBody={
          <RollNumberModal
            refetchStudents={refetchStudents}
            student={student}
            setRollNumberModal={setRollNumberModal}
          />
        }
      />
      <ModalWindow
        modal={registrationNumberModal}
        modalHeader={"Edit Registration Number"}
        toggleModal={() => setRegistrationNumberModal((prev) => !prev)}
        modalBody={
          <RegistrationNumberModal
            refetchStudents={refetchStudents}
            student={student}
            setRegistrationNumberModal={setRegistrationNumberModal}
          />
        }
      />
    </>
  );
};

export default StudentFlipCard;
